/**
 * Deepgram Configuration
 * Configure your Deepgram settings here
 */

const DeepgramConfig = {
  
  // Server URL for token generation
  SERVER_URL: process.env.REACT_APP_SERVER_URL || 'http://localhost:5000',
  
  // Model settings
  MODEL: 'nova-2', // Latest and most accurate model
  LANGUAGE: 'en-US',
  
  // Feature settings
  SMART_FORMAT: true, // Automatic punctuation and capitalization
  INTERIM_RESULTS: true, // Get real-time interim results
  ENDPOINTING: 200, // Milliseconds of silence before finalizing
  VAD_EVENTS: true, // Voice activity detection events
  
  // Audio settings (used in WebSocket URL)
  ENCODING: 'linear16',
  SAMPLE_RATE: 16000,
  CHANNELS: 1,
  
  // Connection settings
  MAX_RECONNECT_ATTEMPTS: 5,
  
  // Enable/disable features
  ENABLED: true, // Master switch for Deepgram
  // Avatar-channel STT. The LiveAvatar AVATAR_TRANSCRIPTION event already provides
  // bot captions, so re-transcribing the avatar's own audio is redundant. Turning
  // this off leaves useDeepgramAvatarIntegration mounted but fully inert (no token
  // fetch, no WebSocket, no MediaRecorder). Flip back to true to restore it.
  AVATAR_STT_ENABLED: true,
  DEBUG_LOGGING: process.env.NODE_ENV === 'development'
};

export default DeepgramConfig;
